/**
 * Collection page: variant pill selection (updates hidden input and add button per card).
 */
function initCollectionVariantPills(section) {
  const scope = section || document;
  scope.querySelectorAll('[data-variants-wrap]').forEach((wrap) => {
    const card = wrap.closest('.collection__card');
    if (!card) return;
    const input = card.querySelector('[data-variant-input]');
    const addButton = card.querySelector('.collection__add-button');
    const pills = wrap.querySelectorAll('[data-variant-pill]');
    if (!input || pills.length === 0) return;
    pills.forEach((pill) => {
      pill.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = pill.getAttribute('data-variant-id');
        if (!variantId) return;
        input.value = variantId;
        pills.forEach((p) => p.classList.remove('collection__variant-pill--active'));
        pill.classList.add('collection__variant-pill--active');
        const available = !pill.disabled;
        if (addButton) {
          addButton.disabled = !available;
          const soldOutText = addButton.getAttribute('data-sold-out-text');
          const addText = addButton.getAttribute('data-add-text');
          const textSpan = addButton.querySelector('.collection__add-button-text');
          if (soldOutText != null && addText != null) {
            if (textSpan) textSpan.textContent = available ? addText : soldOutText;
            else addButton.textContent = available ? addText : soldOutText;
          }
        }
      });
    });
  });
}

function initCollectionSection(section) {
  if (!section) return;
  initCollectionVariantPills(section);
}

function initCollectionSections() {
  document.querySelectorAll('.collection-section').forEach((section) => {
    initCollectionVariantPills(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionSections);
} else {
  initCollectionSections();
}
